import styled from '@emotion/styled';

export const LabelContainer = styled.div`
  display: flex;
`;

export const LabelTag = styled.div`
  align-self: self-end;
  margin-left: 8px;
  padding: 5px 8px;
  border-radius: 4px;
  color: #ff7b0c;
  font-weight: 800;
  font-size: 9px;
  line-height: 11px;
  letter-spacing: 0.2px;
  text-align: center;
  background: rgba(255, 134, 32, 0.14);
`;
